import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import ResourceMaster from "./ResourceMaster";
import EducationDetails from "./EducationDetails";
import AddressDetails from "./AddressDetails";

const ResourceTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Set initial active tab based on current route
  const getInitialTab = () => {
    if (location.pathname.includes('education-details')) {
      return 'education-details';
    }
    if (location.pathname.includes('address-details')) {
      return 'address-details';
    }
    return 'resource-master';
  };

  const [key, setKey] = useState(getInitialTab());

  return (
    <div className="resource-tabs-container">
      <Tabs
        id="resource-tabs"
        activeKey={key}
        onSelect={(k) => {
          setKey(k);
          navigate(`/${k}`);
        }}
        className="mb-3 custom-resource-tabs"
      >
        <Tab 
          eventKey="resource-master" 
          title={<span className={key === 'resource-master' ? 'active-resource-tab' : ''}>Resource Master</span>}
          className="resource-tab-content"
        >
          <ResourceMaster />
        </Tab>
        <Tab 
          eventKey="education-details" 
          title={<span className={key === 'education-details' ? 'active-resource-tab' : ''}>Education Details</span>}
          className="resource-tab-content"
        >
          <EducationDetails />
        </Tab>
        <Tab 
          eventKey="address-details" 
          title={<span className={key === 'address-details' ? 'active-resource-tab' : ''}>Address Details</span>}
          className="resource-tab-content"
        >
          <AddressDetails />
        </Tab>
      </Tabs>
    </div>
  );
};

export default ResourceTabs;